import { ChartCanvas } from "@/components/analytics/ChartCanvas";
import type { ServiceTrendPoint } from "../services.constants";
import { useServiceTrendChartConfig } from "../hooks/useServiceTrendChartConfig";

export function ServiceTrendSection({ trend }: { trend: ServiceTrendPoint[] }) {
  const chartConfig = useServiceTrendChartConfig(trend);

  return (
    <div className="mb-6 rounded-lg border border-border bg-card p-4">
      <p className="mb-0.5 text-[11.5px] font-semibold text-body">Évolution par service</p>
      <p className="mb-3 text-[10.5px] text-muted-foreground">
        CA brut par catégorie, granularité adaptée à la période sélectionnée.
      </p>
      {trend.length === 0 ? (
        <p className="py-12 text-center text-[11.5px] text-muted-foreground">
          Aucune donnée sur cette période.
        </p>
      ) : (
        <ChartCanvas label="Évolution par service" config={chartConfig} />
      )}
    </div>
  );
}
